import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "backdrop", "panel"];

  connect() {
    // Lock body scroll
    document.body.style.overflow = "hidden";
    this.isSlideOver =
      this.hasPanelTarget &&
      this.panelTarget.classList.contains("translate-x-full");

    // Show modal by removing 'hidden' from container
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove("hidden");
    }

    // Initialize modal transitions
    requestAnimationFrame(() => {
      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.add("opacity-100");
      }
      if (this.hasPanelTarget) {
        // Support both centered modals (translate-y-4, scale-95) and slide-overs (translate-x-full)
        this.panelTarget.classList.remove(
          "translate-y-4",
          "opacity-0",
          "scale-95",
          "translate-x-full"
        );
        this.panelTarget.classList.add("translate-x-0");
      }
    });

    // Listen for Escape key
    this._handleKeydown = this._handleKeydown.bind(this);
    document.addEventListener("keydown", this._handleKeydown);
  }

  disconnect() {
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this._handleKeydown);
  }

  close() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("opacity-100");
      this.backdropTarget.classList.add("opacity-0");
    }

    if (this.hasPanelTarget) {
      if (this.isSlideOver) {
        this.panelTarget.classList.add("translate-x-full");
        this.panelTarget.classList.remove("translate-x-0");
      } else {
        this.panelTarget.classList.add(
          "translate-y-4",
          "opacity-0",
          "scale-95"
        );
      }
    }

    setTimeout(() => {
      // Clear the turbo frame content to fully remove the modal
      const modalFrame = document.getElementById("modal");
      if (modalFrame) {
        modalFrame.innerHTML = "";
      }
      document.body.style.overflow = "";
    }, 300);
  }

  clickOutside(event) {
    if (this.hasBackdropTarget && event.target === this.backdropTarget) {
      this.close();
    }
  }

  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  handleSubmit(event) {
    if (event.detail.success) {
      this.close();
    }
  }

  handleTaskSubmit(event) {
    // Only close modal if the event comes from the task form itself
    if (event.detail.success && event.target.closest('[data-controller*="task-form"]')) {
      this.close();
    }
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
}
